import { styled } from '@mui/material/styles';
import { Grid, Stack, Typography } from "@mui/material";
import Box, { BoxProps } from '@mui/material/Box';
import { Breakpoint } from '@mui/system';

import { APP_BAR_HEIGHT } from '../sticky-nav/sticky-nav.const';
import { TEXT_PRIMARY } from '../app.styles';

const FONT_FAMILY = 'Silka, sans-serif';

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
  overflow: 'hidden',
  padding: '64px 32px',
  [theme.breakpoints.up('md')]: { padding: '64px 64px' },
  [theme.breakpoints.up('lg')]: { padding: '64px 96px' },
  [theme.breakpoints.up('xl')]: { padding: '64px 128px' },
}));

export const StyledMusicStack = styled(Stack)({
  width: '100%',
});

export const StyledGrid = styled(Grid)({
  alignItems: 'center',
  overflow: 'hidden',
  width: '100%',
});

export const StyledHeaderTypography = styled(Typography)({
  fontSize: '2rem',
  fontWeight: 600,
  textTransform: 'uppercase',
  fontFamily: FONT_FAMILY,
  letterSpacing: '0.03rem',
  color: TEXT_PRIMARY,
});

export const StyledAlbumGrid = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  overflow: 'hidden',
  gap: '16px',
  flexWrap: 'wrap',
  width: '100%',
});

export const StyledAlbumBox = styled(Box)<BoxProps<'a'>>(({ theme }) => {
  const sizes: { bp: Breakpoint; size: string }[] = [
    { bp: 'xs', size: 'calc(100vw - 64px)' },
    { bp: 'sm', size: 'calc((100vw - 64px - 32px) / 2)' },
    { bp: 'md', size: 'calc((100vw - 128px - 48px) / 3)' },
    { bp: 'lg', size: 'calc((100vw - 192px - 64px) / 4)' },
    { bp: 'xl', size: 'calc((100vw - 256px - 80px) / 5)' },
  ];
  const responsive = sizes.reduce((acc, { bp, size }) => {
    acc[theme.breakpoints.up(bp)] = { height: size, width: size };
    return acc;
  }, {} as Record<string, any>);

  return {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0',
    height: sizes[0].size,
    width: sizes[0].size,
    ...responsive,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    '& .album-overlay': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      opacity: 0,
      transition: 'opacity 0.3s',
    },
    '&:hover .album-overlay': {
      opacity: 1,
    },
  };
});

const albumTextBase = {
  fontFamily: FONT_FAMILY,
  letterSpacing: '0.03rem',
};

export const StyledAlbumArtistTypography = styled(Typography)({
  ...albumTextBase,
  fontSize: '0.75rem',
  textTransform: 'uppercase',
});

export const StyledAlbumTitleTypography = styled(Typography)({
  ...albumTextBase,
  textAlign: 'center',
  fontSize: '1.05rem',
  padding: '0 16px',
  fontWeight: 600,
});

export const StyledAlbumYearTypography = styled(Typography)({
  ...albumTextBase,
  fontSize: '0.75rem',
  textTransform: 'uppercase',
});
